import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {GridCell, GridContainer} from "../../../../Components/Grid";
import {Allow, policyEvents} from "../../../../Components/Authorize";

interface AphCatalogItemProps {
    id?: string;
    catalogNumber?: string;
    title?: string;
    cost?: number;
    handleClickEdit?: () => void;
    [key: string]: unknown;
}

export const AphCatalogItem = ({
                                   id,
                                   catalogNumber,
                                   title,
                                   cost,
                                   handleClickEdit,
                               }: AphCatalogItemProps) => {

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>
            <GridCell>
                {
                    handleClickEdit &&
                    <Allow policyEvent={policyEvents.MANAGE_APH_CATALOG_ITEMS}>
                        <div className={`align-right margin--topNegative`}>
                            <ButtonLinkStyle
                                label={`Edit Item`}
                                name={`btnEdit${id}`}
                                onClick={handleClickEdit}
                            />
                        </div>
                    </Allow>
                }
                <h3 id={`title${id}`} className={`margin--bottomNone`}>
                    {title}
                </h3>
                <p><strong>Catalog Number:</strong> {catalogNumber}</p>
                {cost && <p><strong>Cost:</strong> ${cost.toFixed(2)}</p>}
            </GridCell>
        </GridContainer>
    </>;
};
